import Logo from '@/assets/icons/dashboard/sidebar-main-logo.svg';
import HomeIcon from '@/assets/icons/dashboard/sidebar/home.svg';
import MedboxIcon from '@/assets/icons/dashboard/sidebar/medbox.svg';
import BoxIcon from '@/assets/icons/dashboard/sidebar/box.svg';
import BillingIcon from '@/assets/icons/dashboard/sidebar/billing.svg';
import UserIcon from '@/assets/icons/dashboard/sidebar/account.svg';
import { Link, useLocation } from 'react-router-dom';
import { useMediaQuery, useTheme } from '@mui/material';

const options: { title: string; name: string, mobileTitle?: string; icon: string; link: string }[] = [
    {
        title: 'Home',
        icon: HomeIcon,
        name: 'home',
        link: '/dashboard/home'
    },
    {
        title: 'My MedBox',
        mobileTitle: 'MedBox',
        icon: MedboxIcon,
        name: 'my-medbox',
        link: '/dashboard/my-medbox'
    },
    {
        title: 'Shipments',
        icon: BoxIcon,
        name: 'shipments',
        link: '/dashboard/shipments'
    },
    {
        title: 'Billing',
        icon: BillingIcon,
        name: 'billing',
        link: '/dashboard/billing'
    },
    {
        title: 'My Account',
        mobileTitle: 'Account',
        icon: UserIcon,
        name: 'my-account',
        link: '/dashboard/my-account'
    }
];

const Sidebar = () => {
    const { pathname } = useLocation();
    const theme = useTheme();
    const isSmallMobile = useMediaQuery(theme.breakpoints.down(420));

    return (
        <div data-testid="dashboard-sidebar-container" className="fixed bottom-0 z-[60] w-full overflow-hidden rounded-t-md bg-[#fbfbfb] shadow-dashboardSidebarMobile lg:static lg:h-full lg:rounded-none lg:shadow-dashboardSidebar">
            <div data-testid="dashboard-sidebar-content" className="static w-full px-0 py-0 lg:fixed lg:w-[224px] lg:px-[18px] lg:pt-11 lx:w-[267px]">
                <div className="flex flex-col items-center gap-11">
                    <div className="hidden w-full pl-6 lg:block">
                        <Link data-testid="dashboard-sidebar-logo-link" to="/dashboard" className="inline-block w-max">
                            <img src={Logo} alt="" className="max-w-36" />
                        </Link>
                    </div>
                    <ul data-testid="dashboard-sidebar-navigator" className="flex w-full max-w-full items-center gap-0 lg-max:h-[4.375rem] lg:flex lg:w-full lg:flex-col lg:items-start lg:gap-5">
                        {options.map(option => (
                            <li data-testid={`dashboard-sidebar-link-wrapper-${option.name}`} key={option.link + 'link'} className="w-full flex-auto lg-max:h-full">
                                <Link
                                    to={option.link}
                                    data-testid={`dashboard-sidebar-link-${option.name}`}
                                    className={`flex h-full w-full flex-col lg-max:justify-center items-center gap-1.5 py-2.5 duration-200 lg:hover:bg-mint-200 lg:flex-row lg:gap-5 lg:rounded-md lg:px-5 ${pathname.includes(option.link) ? 'bg-mint-200 shadow-dashboardSidebarLink lg:bg-[#565F5D26]' : ''}`}
                                >
                                    <img src={option.icon} alt="" className="max-w-6 md:max-w-7" />
                                    <span data-testid={`dashboard-sidebar-link-text-${option.name}`} className="sm:text-ms font-atkinsonHyperlegible text-xs uppercase text-primary-700 lg:text-lg lg:normal-case lg:text-primary-800 lx:text-xl">
                                        {isSmallMobile
                                            ? option.mobileTitle || option.title
                                            : option.title}
                                    </span>
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default Sidebar;
